export default __webpack_public_path__ + "static/smurfit-kappa-f486460657315c91079d21c0351b649d.jpg";